import React from 'react';
import { SiteSection } from '../../../../components/site';
import type { ProductEduIntroConfig } from '../../../product-subpage/types';

export const PlatformEduIntro: React.FC<{ eduIntro: ProductEduIntroConfig }> = ({ eduIntro }) => (
  <SiteSection className="platform-edu-intro platform-edu-intro--premium">
    <div className="platform-edu-intro__inner">
      <h2 className="platform-edu-intro__title">{eduIntro.title}</h2>
      <p className="platform-edu-intro__desc">{eduIntro.description}</p>
    </div>
  </SiteSection>
);
